// KPI Period Sagas

import { call, put, takeLatest } from 'redux-saga/effects';
import apiRequest from '@libs/apiRequest';
import { setSnack } from 'utilities/redux.actions';
import * as actionTypes from './redux.actionTypes';
import * as actions from './redux.actions';
import { API_ENDPOINTS, SUCCESS_MESSAGES, getErrorMessage } from './common';

// Fetch Periods Saga
function* fetchPeriodsSaga(action) {
  try {
    const params = action.payload || {};
    const response = yield call(apiRequest, {
      url: API_ENDPOINTS.GET_ALL,
      method: 'GET',
      params: {
        limit: params.limit,
        offset: params.offset,
        search: params.search,
      },
    });

    yield put(actions.fetchPeriodsSuccess(response.data));
  } catch (error) {
    const errorMessage = getErrorMessage(error, 'Failed to fetch KPI periods');
    yield put(actions.fetchPeriodsFailure(errorMessage));
    yield put(
      setSnack({
        message: errorMessage,
        severity: 'error',
      })
    );
  }
}

// Fetch Period by ID Saga
function* fetchPeriodByIdSaga(action) {
  try {
    const periodId = action.payload;
    const response = yield call(apiRequest, {
      url: `${API_ENDPOINTS.GET_BY_ID}/${periodId}`,
      method: 'GET',
    });

    yield put(actions.fetchPeriodByIdSuccess(response.data));
  } catch (error) {
    const errorMessage = getErrorMessage(error, 'Failed to fetch KPI period details');
    yield put(actions.fetchPeriodByIdFailure(errorMessage));
    yield put(
      setSnack({
        message: errorMessage,
        severity: 'error',
      })
    );
  }
}

// Create Period Saga
function* createPeriodSaga(action) {
  try {
    const response = yield call(apiRequest, {
      url: API_ENDPOINTS.CREATE,
      method: 'POST',
      data: JSON.stringify(action.payload),
    });

    yield put(actions.createPeriodSuccess(response.data));
    yield put(
      setSnack({
        message: SUCCESS_MESSAGES.CREATE,
        severity: 'success',
      })
    );

    // Refresh the periods list
    yield put(actions.fetchPeriodsRequest({}));
  } catch (error) {
    const errorMessage = getErrorMessage(error, 'Failed to create KPI period');
    yield put(actions.createPeriodFailure(errorMessage));
    yield put(
      setSnack({
        message: errorMessage,
        severity: 'error',
      })
    );
  }
}

// Update Period Saga
function* updatePeriodSaga(action) {
  try {
    const { id, data } = action.payload;
    const response = yield call(apiRequest, {
      url: `${API_ENDPOINTS.UPDATE}/${id}`,
      method: 'PUT',
      data: JSON.stringify(data),
    });

    yield put(actions.updatePeriodSuccess(response.data));
    yield put(
      setSnack({
        message: SUCCESS_MESSAGES.UPDATE,
        severity: 'success',
      })
    );

    // Refresh the periods list
    yield put(actions.fetchPeriodsRequest({}));
  } catch (error) {
    const errorMessage = getErrorMessage(error, 'Failed to update KPI period');
    yield put(actions.updatePeriodFailure(errorMessage));
    yield put(
      setSnack({
        message: errorMessage,
        severity: 'error',
      })
    );
  }
}

// Delete Period Saga
function* deletePeriodSaga(action) {
  try {
    const periodId = action.payload;
    yield call(apiRequest, {
      url: `${API_ENDPOINTS.DELETE}/${periodId}`,
      method: 'DELETE',
    });

    yield put(actions.deletePeriodSuccess(periodId));
    yield put(
      setSnack({
        message: SUCCESS_MESSAGES.DELETE,
        severity: 'success',
      })
    );
  } catch (error) {
    const errorMessage = getErrorMessage(error, 'Failed to delete KPI period');
    yield put(actions.deletePeriodFailure(errorMessage));
    yield put(
      setSnack({
        message: errorMessage,
        severity: 'error',
      })
    );
  }
}

// Root Saga
export default function* kpiPeriodSaga() {
  yield takeLatest(actionTypes.FETCH_PERIODS_REQUEST, fetchPeriodsSaga);
  yield takeLatest(actionTypes.FETCH_PERIOD_BY_ID_REQUEST, fetchPeriodByIdSaga);
  yield takeLatest(actionTypes.CREATE_PERIOD_REQUEST, createPeriodSaga);
  yield takeLatest(actionTypes.UPDATE_PERIOD_REQUEST, updatePeriodSaga);
  yield takeLatest(actionTypes.DELETE_PERIOD_REQUEST, deletePeriodSaga);
}
